import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, Icon, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import DialogBase from './DialogBase';
import { getRoleLabel, OrganisatieUserRole } from '../../../models/user/userRole';

interface DialogUpdateUserRoleProps {
  open: boolean;
  email?: string | null;
  currentRole: OrganisatieUserRole;
  allowedRoles: OrganisatieUserRole[];
  onClose: () => void;
  onSubmit: (nextRole: OrganisatieUserRole) => void;
}

const DialogUpdateUserRole: React.FC<DialogUpdateUserRoleProps> = ({
  open,
  email,
  currentRole,
  allowedRoles,
  onClose,
  onSubmit,
}) => {
  const [selectedRole, setSelectedRole] = useState<OrganisatieUserRole>(currentRole);

  useEffect(() => {
    if (open) {
      setSelectedRole(currentRole);
    }
  }, [open, currentRole]);

  const handleRoleChange = (event: SelectChangeEvent<string>) => {
    setSelectedRole(event.target.value as OrganisatieUserRole);
  };

  const handleSubmit = () => {
    onSubmit(selectedRole);
  };

  return (
    <DialogBase
      open={open}
      title="Rol aanpassen"
      contentText={`Wijzig de rol voor ${email ?? 'de gebruiker'}. De huidige rol wordt eerst verwijderd en daarna wordt de nieuwe rol gekoppeld.`}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmButtonText="Opslaan"
      confirmButtonIcon={<Icon>save</Icon>}
    >
      <section>
        <label>Kies de nieuwe rol</label>
        <br />

        <FormControl fullWidth variant="filled" error={selectedRole === 'admin'}>
          <InputLabel id="select-role-label">Rol</InputLabel>
          <Select
            labelId="select-role-label"
            id="select-role"
            value={selectedRole}
            onChange={handleRoleChange}
            label="Rol"
          >
            {allowedRoles.map((role) => (
              <MenuItem key={role} value={role}>
                {getRoleLabel(role)}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{selectedRole === 'admin' ? 'Admin rol wijzigen wordt niet ondersteund via deze API.' : ' '}</FormHelperText>
        </FormControl>
      </section>
    </DialogBase>
  );
};

export default DialogUpdateUserRole;